import './App.css';
import './Pages/css/main.css'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Header from './Pages/nav/header';
import Footer from './Pages/nav/footer';
import Sidebar from './Pages/nav/sidebar';

import Dashboard from './Pages/dashboard';
import Login from './Pages/login';
import Sugi from './Pages/sugi';
import SugiInbiz from './Pages/sugiInbiz';
import Paylist from './Pages/paylist';
import Notice from './Pages/notice';
import Settlement from './Pages/settlement';
import CreateMerchant from './Pages/createMerchant';
import Withdraw from './Pages/withdraw';
import CreateMerchantsAgent from './Pages/createMerchantsAgent';
import UrlCreate from './Pages/urlCreate';
import UrlPayment from './Pages/urlPayment';
import UrlHistory from './Pages/urlHistory';
import UrlComplete from './Pages/urlComplete';
import UrlDetail from './Pages/urlDetail';
import UrlUserHistory from './Pages/urlUserHistory';
import UrlNotice from './Pages/urlNotice';
import SmsPayment from './Pages/smsPayment';
import SmsAuthPayment from './Pages/smsAuthPayment';
import SmsPaymentPublic from './Pages/smsPaymentPublic';
import SmsAuthPaymentPublic from './Pages/smsAuthPaymentPublic';

// V2 Pages
import PaylistV2 from './Pages/v2/paylist';
import TestV2 from './Pages/v2/test';

import ErrorBoundary from './Pages/common/ErrorBoundary'
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change_hostLogoImg, setMyData } from './store';

function App() {
  let location = useLocation();
  let dispatch = useDispatch();
  const MyData = useSelector((state) => state.MyData);

  useEffect(() => {
    if (window.location.hostname == "cp.onu-terminal.com") {
      dispatch(change_hostLogoImg("onu"))
    }
    else if (process.env.REACT_APP_HOST_BRAND === "baekma") {
      dispatch(change_hostLogoImg("baekma"))
    }
    else {
      dispatch(change_hostLogoImg("fast"))
    }
    
    // localStorage에서 사용자 정보를 Redux store에 로드
    const userData = localStorage.getItem("userId");
    if (userData) {
      try {
        const parsedUserData = JSON.parse(userData);
        dispatch(setMyData(parsedUserData));
      } catch (error) {
        console.error("사용자 정보 파싱 오류:", error);
      }
    }
  }, [])

  const isV2Route = location.pathname.startsWith('/v2');

  // V2 라우트는 별도로 처리 (기존 Header/Sidebar 없이)
  if (isV2Route) {
    // 디버깅 정보 저장 (매번 실행)
    try {
      localStorage.setItem('v2_debug', JSON.stringify({
        pathname: location.pathname,
        timestamp: new Date().toISOString(),
        hasUserData: !!localStorage.getItem("userId"),
        userData: localStorage.getItem("userId")
      }));
    } catch (e) {
      // localStorage 에러 무시
    }
    
    // V2 라우트는 로그인 체크 (로그인 페이지 제외)
    // 테스트 페이지는 로그인 체크 제외
    const userData = localStorage.getItem("userId");
    if (!userData && location.pathname !== '/' && location.pathname !== '/v2/test') {
      // 로그인하지 않은 경우 로그인 페이지로 리다이렉트
      return <Navigate to="/" replace />;
    }

    return (
      <div className="App" style={{ width: '100%', height: '100vh', overflow: 'hidden', position: 'fixed', top: 0, left: 0 }}>
        <ErrorBoundary>
          <Routes>
            <Route path="/v2/test" element={<TestV2 />} />
            <Route path="/v2/paylist" element={<PaylistV2 />} />
            <Route path="/v2/*" element={<div style={{ padding: '20px' }}>V2 페이지를 찾을 수 없습니다. 경로: {location.pathname}</div>} />
          </Routes>
        </ErrorBoundary>
      </div>
    );
  }

  // V1 라우트 로그인 체크 (공개 페이지 제외)
  const publicPaths = [
    '/',
    '/createMerchantsAgent',
    '/urlPayment',
    '/urlComplete',
    '/urlDetail',
    '/urlUserHistory',
    '/urlNotice',
    '/sms',
    '/smsa',
    '/urlPayment/sms',
    '/urlPayment/smsa',
  ];
  const isPublicPath = publicPaths.includes(location.pathname);
  if (!localStorage.getItem("userId") && !isPublicPath) {
    return <Navigate to="/" replace />;
  }

  // 기존 V1 라우트
  return (
    <div className="App" style={{ maxWidth: "1920px", margin: "0 auto" }}>
      <div className={location.pathname === '/urlPayment' ? 'header' : 'py-0 md:py-5 header'}>
        {location.pathname !== '/urlPayment' && <Header />}
        <div className='section1'>
          <Sidebar />
          <div className={`section2 ${location.pathname == '/'
              || location.pathname == '/createMerchantsAgent'
              || location.pathname == '/urlComplete'
              || location.pathname == '/sms'
              || location.pathname == '/smsa'
              || location.pathname.startsWith('/urlPayment/sms')
              ? "main" : ""}`}>
            <ErrorBoundary>
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/dashboard" element={<Dashboard />} />
                {MyData.sugi_expose == "Y"
                  ?
                  <Route path="/sugi" element={
                    process.env.REACT_APP_HOST_BRAND === "baekma" ? <SugiInbiz /> : <Sugi />
                  } />
                  : ""}

                {MyData.urlpay == 1
                  ?
                  <>
                    <Route path="/urlCreate" element={<UrlCreate />} />
                    <Route path="/urlHistory" element={<UrlHistory />} />
                  </>
                  : ""}

                {/* <Route path="/sugi" element={<Sugi />} /> */}
                {/* <Route path="/urlCreate" element={<UrlCreate />} /> */}
                {/* <Route path="/urlHistory" element={<UrlHistory />} /> */}

                <Route path="/paylist" element={<Paylist />} />
                <Route path="/notice" element={<Notice />} />
                <Route path="/settlement" element={<Settlement />} />
                <Route path="/withdraw" element={<Withdraw />} />
                <Route path="/createMerchantsAgent" element={<CreateMerchantsAgent />} />
                <Route path="/urlPayment" element={<UrlPayment />} />
                <Route path="/urlComplete" element={<UrlComplete />} />
                <Route path="/urlDetail" element={<UrlDetail />} />
                <Route path="/urlUserHistory" element={<UrlUserHistory />} />
                <Route path="/urlNotice" element={<UrlNotice />} />

                {MyData.smsKYC == 1
                  ?
                  <Route path="/smsPayment" element={<SmsPayment />} />
                  : ""}

                {MyData.smsConfirm == 1
                  ?
                  <Route path="/smsAuthPayment" element={<SmsAuthPayment />} />
                  : ""}

                {/* 공개 결제 페이지 (인증 불필요) */}
                <Route path="/sms" element={<SmsPaymentPublic />} />
                <Route path="/smsa" element={<SmsAuthPaymentPublic />} />
                {/* 백엔드 호환성을 위한 추가 라우트 */}
                <Route path="/urlPayment/sms" element={<SmsPaymentPublic />} />
                <Route path="/urlPayment/smsa" element={<SmsAuthPaymentPublic />} />

                {/* <Route path="/createMerchant" element={<CreateMerchant />} /> */}

                {MyData.sugi_expose == "Y"
                  ?
                  <Route path="*" element={<Navigate to="/dashboard" />} />
                  :
                  <Route path="*" element={<Navigate to="/paylist" />} />
                }
              </Routes>
            </ErrorBoundary>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
